// Commerce adapter router — switch between Shopify and Stripe without changing consumers
const provider = process.env.GATSBY_COMMERCE_PROVIDER || 'stripe'

const commerce =
  provider === 'shopify'
    ? require('./shopify-adapter').default
    : require('./stripe-adapter').default

export default commerce
